import {
  getNewest,
  getMenu,
  getMenuTree,
  getLoginInfo,
  ssoLogin,
} from "@/api/home";
import { MAP_ACTION, PERMISSION_ROLE } from "@/utils/constant";
import { handleTree } from "@/utils/common";

const state = {
  // 用户信息
  userInfo: {},
  // 是否登录
  isLogin: false,
  // 最后获取登录信息的时间
  lastLoginInfoUpdateTime: 0,
  // 是否已经获取过对应的 可见栏目
  role: new Map(),
  // 所有的可见栏目
  menus: [],
  // 所有的menu, 不区分 是否显示, list
  allMenusList: [],
  // 所有的menu 树
  allMenusTree: [],
  // 站点信息
  siteInfo: {},
  // 当前选中的菜单
  activeMenu: {},
  // 当前详情的标题
  curDetailTitle: "",
  // 底部导航
  bottomNavList: [],
};

const mutations = {
  SET_USER_INFO: (state, info) => {
    state.userInfo = info || {};
    state.isLogin = !!info.userGuid;
    // 更新最后获取时间
    state.lastLoginInfoUpdateTime = Date.now();
  },
  SET_ROLE: (state, { action, role }) => {
    state.role[action](role, role);
  },
  SET_MENUS: (state, menus) => {
    state.menus = menus || [];
  },
  SET_ALL_MENUS_LIST: (state, menus) => {
    state.allMenusList = menus || [];
  },
  SET_ALL_MENUS_TREE: (state, menus) => {
    state.allMenusTree = menus || [];
  },
  SET_SITE_INFO: (state, info) => {
    state.siteInfo = info || {};
  },
  SET_ACTIVE_MENU: (state, activeMenu) => {
    state.activeMenu = activeMenu || {};
  },
  SET_DETAIL_TITLE: (state, title) => {
    state.curDetailTitle = title;
  },
  SET_BOTTOM_NAV: (state, arr) => {
    state.bottomNavList = arr;
  },
};

const actions = {
  // 获取栏目树
  getMenuList({ commit }) {
    return new Promise((resolve) => {
      getMenuTree()
        .then((resp) => {
          commit("SET_ROLE", {
            action: MAP_ACTION.SET,
            role: PERMISSION_ROLE.MENU,
          });
          commit("SET_MENUS", resp.data);
          resolve(resp.data);
        })
        .catch(() => {
          commit("SET_ROLE", {
            action: MAP_ACTION.DEL,
            role: PERMISSION_ROLE.MENU,
          });
          commit("SET_MENUS", []);
        });
    });
  },
  getMenuListAll({ commit }) {
    return new Promise((resolve) => {
      getMenu().then((resp) => {
        commit("SET_ALL_MENUS_LIST", resp.data);
        commit(
          "SET_BOTTOM_NAV",
          resp.data.filter((item) => item.isNav),
        );
        commit("SET_ALL_MENUS_TREE", handleTree(resp.data));
        resolve(resp.data);
      });
    });
  },
  // 获取站点信息
  getSiteInfo({ commit }) {
    return new Promise((resolve) => {
      getNewest()
        .then((resp) => {
          commit("SET_ROLE", {
            action: MAP_ACTION.SET,
            role: PERMISSION_ROLE.SITE,
          });
          commit("SET_SITE_INFO", resp.data);
          resolve(resp.data);
        })
        .catch(() => {
          commit("SET_ROLE", {
            action: MAP_ACTION.DEL,
            role: PERMISSION_ROLE.SITE,
          });
          commit("SET_SITE_INFO", []);
        });
    });
  },
  changeActiveMenu({ commit, state }, menu) {
    commit("SET_ACTIVE_MENU", menu);
  },
  getActiveMenu({ commit, state }, route) {
    const {
      params: { code },
      path,
    } = route;

    let menu =
      state.allMenusList.find(
        (item) => item.path === path || item.code === code,
      ) || {};

    if (menu.parentId) {
      menu = state.allMenusList.find((item) => item.id === menu.parentId) || {};
    }

    commit("SET_ACTIVE_MENU", menu);
  },
  async checkAndUpdateUserInfo({ commit, getters }, { isNbRoute }) {
    const THIRTY_MINUTES = 1800000;
    const currentTime = Date.now();
    const {
      userInfo: currentUserInfo,
      lastLoginInfoUpdateTime = 0,
      isLogin,
    } = getters;

    const hasUserInfo =
      currentUserInfo && Object.keys(currentUserInfo).length > 0;
    const isExpired = currentTime - lastLoginInfoUpdateTime > THIRTY_MINUTES;
    const shouldUpdate = isNbRoute || !hasUserInfo || (isLogin && isExpired);

    if (shouldUpdate) {
      try {
        const token = window.location.search.match(/[?&]token=([^&]*)/)?.[1];
        if (token) {
          await ssoLogin(token);
        }
        const userRes = await getLoginInfo();
        commit("SET_USER_INFO", userRes.data);
      } catch (error) {
        console.error("获取用户信息失败:", error);
      }
    }
  },
  // 加载页面必要资源
  async loadPageResources({ state, dispatch }, to) {
    // 加载菜单和站点信息（非关键路径）
    const roleMap = state.role;

    // 加载菜单列表
    if (!roleMap.has(PERMISSION_ROLE.MENU)) {
      await Promise.all([dispatch("getMenuList"), dispatch("getMenuListAll")]);
    }

    // 加载站点信息
    if (!roleMap.has(PERMISSION_ROLE.SITE)) {
      await dispatch("getSiteInfo");
    }

    // 设置当前激活菜单
    await dispatch("getActiveMenu", to);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
